import React from "react";
import { Database, RefreshCw } from "lucide-react";

export default function AdminPartnerImportsList({
  imports,
  loading,
  onRefresh,
}) {
  return (
    <div className="border border-zinc-900 bg-white mt-6" data-testid="admin-partner-imports-list">
      <div className="px-5 py-3 border-b border-zinc-900 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Database size={14} className="text-red-600" />
          <span className="label-eyebrow">Partner imports · audit log</span>
          <span className="text-[10px] font-bold text-zinc-500">
            ({imports.length})
          </span>
        </div>
        <button
          onClick={onRefresh}
          disabled={loading}
          className="text-[10px] uppercase tracking-widest font-bold text-zinc-700 hover:text-red-600 inline-flex items-center gap-1 disabled:opacity-50"
          data-testid="admin-partner-imports-refresh"
        >
          <RefreshCw size={11} className={loading ? "animate-spin" : ""} />
          Refresh
        </button>
      </div>

      <div className="divide-y divide-zinc-200 max-h-[320px] overflow-auto">
        {imports.length === 0 && !loading && (
          <div className="p-6 text-sm text-zinc-500">
            No partner imports yet. Load a batch via{" "}
            <code className="font-mono text-xs bg-zinc-100 px-1.5 py-0.5">
              POST /api/admin/partners/import
            </code>
            .
          </div>
        )}
        {imports.map((imp) => (
          <div
            key={imp.id}
            className="p-4 grid grid-cols-1 sm:grid-cols-12 gap-2 items-center"
            data-testid={`partner-import-row-${imp.id}`}
          >
            <div className="sm:col-span-4">
              <div className="font-display font-black text-sm tracking-tight">
                {imp.partner_org}
              </div>
              <div className="text-[11px] text-zinc-500 font-mono">
                {imp.agreement_reference}
              </div>
            </div>
            <div className="sm:col-span-4 text-xs text-zinc-700">
              <span className="text-emerald-700 font-bold">
                {imp.inserted}
              </span>{" "}
              new ·{" "}
              <span className="text-amber-700 font-bold">{imp.updated}</span>{" "}
              updated
            </div>
            <div className="sm:col-span-4 text-[11px] text-zinc-500 text-right">
              {new Date(imp.imported_at).toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
